import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

const Footer = ({ openCookies }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__content">
        <p className="footer__description">
          The Guide Tool processes your registration and
          questionnaire data to display your readiness level and generate
          recommendations. We also use aggregated data to manage
          and improve the tool, as well as for research purposes.
        </p>

        <div className="footer__legal">
          <span>Copywriting © {currentYear} NextGen Solutions</span>
          <div className="footer__links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/impressum">Imprint</Link>

            <button onClick={openCookies} className="footer__cookie-link">
              Cookie Settings
            </button>
            <a
              href="mailto:support@nextgensolutions.com"
              className="footer__contact-link"
              style={{ textDecoration: "none" }}
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
